module.exports = __webpack_public_path__ + "img/st-icon-3.e859b2a0.png";